export default {
	token: window.localStorage.getItem("token"),
	// url: "https://apicn.311419.cn",
	url: "https://quick.91mgame.com",
	// url: "https://game.buercamp.com",
	// url : "http://120.27.212.253:1419",
	// url : "http://127.0.0.1:1419",
	isLogined: false,
	user: null,
	login(token) {
		this.token = token;
		window.localStorage.setItem("token", token);
	},
	logout() {
		this.token = null;
	},
	set(key, value) {
		window.localStorage.setItem(key, value)
		// uni.setStorageSync(key, value);
	},
	get(key) {
		return window.localStorage.getItem(key)

		// let v = uni.getStorageSync(key)
		// if (v == "") {
		// 	return null
		// }
		// return v;
	},
}